import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Company } from 'src/app/lem/models/companies/company';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { environment } from 'src/environments/environment';
import {CompanyScope} from '../../../models/companies/company-scope';
import {CompanyType} from '../../../models/companies/company-type';
import {CompanyStatus} from '../../../models/companies/company-status';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Pagable } from 'src/app/lem/models/common/pagable';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  companyPath = ServicePathsSettings.URL_COMPANIES ;
  companyStatusesPath = this.companyPath +  ServicePathsSettings.URL_COMPANIES_STATUSES;
  scopesPath = this.companyPath + ServicePathsSettings.URL_SCOPES;
  typesPath = this.companyPath +  ServicePathsSettings.URL_TYPES;

  // companyPath = "http://localhost:8080/companies" ;
  // scopesPath = this.companyPath  + "/scopes";
  // typesPath = this.companyPath  + "/types";

  private _refreshRequired$ = new Subject<void>();

  constructor(
    private http : HttpClient,
  ) { }

  get RefreshRequired$ () {
    return this._refreshRequired$.asObservable();
  }


  addCompany  (company : Company) : Observable<Company> {
    return this.http.post<Company>(this.companyPath,company).pipe(tap(()=>{this._refreshRequired$.next();}));
  }
  editCompany (company : Company) : Observable<Company> {
    console.log(company)
    return this.http.put<Company>(this.companyPath + "/"+company.id,company).pipe(tap(()=>{this._refreshRequired$.next();}));;
  }
  deleteCompany (company : Company) : Observable<Object> {
    return this.http.delete<Object>(this.companyPath+ "/"+company.id).pipe(tap(()=>{this._refreshRequired$.next();}));;
  }

  searchCompany(companyObj, pagable: Pagable) : Observable<PaginatedResponse<Company>> {
    let params = new HttpParams({ fromObject: companyObj});
    if(pagable){
      params = params.append('page', ''+pagable.page);
      params = params.append('size', ''+pagable.size);
    }
    return this.http.get<PaginatedResponse<Company>>(this.companyPath,{ params: params });
  }

  getAllCompanyStatuses () : Observable<CompanyStatus[]> {
    return this.http.get<CompanyStatus[]>(this.companyStatusesPath)
  }

  getAllCompanyTypes () : Observable<CompanyType[]> {
    return this.http.get<CompanyType[]>(this.typesPath)
  }

  getAllCompanyScopes () : Observable<CompanyScope[]> {
    return this.http.get<CompanyScope[]>(this.scopesPath)
  }

  getAllCompany() : Observable<PaginatedResponse<Company>>{
    return this.http.get<PaginatedResponse<Company>>(this.companyPath);
  }

  findById(id: string): Observable<Company> {
    return this.http.get<Company>(this.companyPath + '/' + id);
  }



}
